"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var EmailExclusivesProductCard_1 = require("./EmailExclusivesProductCard");
var EmailExclusivesProductCards = function (_a) {
    var isBundle = _a.isBundle, products = _a.products, bundleDiscount = _a.bundleDiscount;
    return ((0, preact_1.h)("div", { class: "shop-all-products" }, products.map(function (product, index) { return ((0, preact_1.h)(EmailExclusivesProductCard_1.default, { key: product.id, index: index, isBundle: isBundle, product: product, bundleDiscount: bundleDiscount })); })));
};
exports.default = EmailExclusivesProductCards;
